import { Box, Container } from '@mui/material';
import { useSessionContext } from '@src/modules';
import { FC, PropsWithChildren } from 'react';
import { NavBar } from '../nav-bar';
import { PwaInstallPrompt } from '../pwa-install';
import { Footer } from './footer';
import { Header } from './header';

const AppLayout: FC<PropsWithChildren> = ({ children }) => {
  const { userLogged } = useSessionContext();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Header />
      <NavBar>
        {/*
          Deslogado o NavBar não renderiza o drawer, então nada empurra o conteúdo
          e a margem automática é o que devolve o bloco ao meio da janela. Logado,
          o drawer já ocupa a esquerda e a margem zero mantém o conteúdo colado nele.
        */}
        <Container disableGutters sx={{ maxWidth: { md: '1152px' }, margin: userLogged ? 0 : '0 auto', flex: 1 }}>
          {children}
        </Container>
      </NavBar>
      <Footer />

      {/*
        Fica no layout, e não numa página: o convite vale em qualquer tela, e
        quem decide se aparece é ele mesmo -- plataforma, histórico de acessos
        e recusa anterior.
      */}
      <PwaInstallPrompt />
    </Box>
  );
};

export { AppLayout };
